import {EntityBase} from "../../../shared/entity/EntityBase";

const SEASON_THEME_MASTER_TABLE_FIELDS = {
    index: { type: Number, defaultValue: 0 },
    resourceIdx: { type: Number, defaultValue: 1 },
    openLevel: { type: Number, defaultValue: 1 },
    name: { defaultValue: '' },
}

export class SeasonThemeMasterTableEntity extends EntityBase {
    constructor(data = {}) {
        super(data, SEASON_THEME_MASTER_TABLE_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
        ];
    }
}